import { useCallback } from 'react';
import type { FunctionComponent } from 'react';

import { useLocation, useParams } from '../../../contexts/RouterContext';
import { getProjectBaseURLFromParams } from '../../../utils';
import SidebarNavLayout from '../../layouts/SidebarNavLayout';
import type { RevisionRouteParams } from '../projectDashboardTypes';

/**
 * InventoryBrowseContainer - When Snippet Detection is enabled, this will display the sidebar nav for
 * both the Dependencies and Snippets (now grouped together as "Inventory").
 */
const InventoryBrowseContainer: FunctionComponent = ({ children }) => {
  const params = useParams<RevisionRouteParams>();
  const location = useLocation();

  const baseProjectURL = getProjectBaseURLFromParams(params);
  const isPathActive = useCallback((pathPart: 'dependencies' | 'snippets') => {
    const pathWithoutTrailingSlash = location.pathname.replace(/\/$/, '');
    return pathWithoutTrailingSlash.endsWith(pathPart);
  }, [location.pathname]);

  return (
    <SidebarNavLayout>
      <SidebarNavLayout.Nav>
        <SidebarNavLayout.NavItem
          to={`${baseProjectURL}/browse/dependencies`}
          isActive={isPathActive('dependencies')}
        >
          Dependencies
        </SidebarNavLayout.NavItem>
        <SidebarNavLayout.NavItem
          to={`${baseProjectURL}/browse/snippets`}
          isActive={isPathActive('snippets')}
        >
          Snippets
        </SidebarNavLayout.NavItem>
      </SidebarNavLayout.Nav>
      <SidebarNavLayout.Content>
        {children}
      </SidebarNavLayout.Content>
    </SidebarNavLayout>
  );
};

export default InventoryBrowseContainer;
